import axios from 'axios';

export default {
  state: {
    productStore: {},
    loading: false,
    error: null,
    productStoreLoaded: false
  },
  mutations: {
    SET_PRODUCT_STORE(state, productStore) {
      state.productStore = productStore;
      state.productStoreLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_PRODUCT_STORE_LOADING(state, status) {
      state.productStoreLoading = status;
    },
    UNSET_PRODUCT_STORE(state) {
      state.productStoreLoaded = false;
      state.productStoreLoading = false;
      state.productStore = {};
    },
    SET_PRODUCT_STORE_ERROR(state, error) {
      state.productStoreError = error;
    }
  },
  actions: {
    async fetchProductStore({ commit, state }, id) {
      // Проверяем, были ли категории уже загружены
      if (state.loaded && state.productStore) {
        //return; // Если данные уже загружены, прекращаем выполнение
      }

      try {
        commit('SET_PRODUCT_STORE_LOADING', true);
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/catalog/detail/'+id+'/store/');
        commit('SET_PRODUCT_STORE', response.data.data);
        commit('SET_PRODUCT_STORE_ERROR', null);
      } catch (error) {
        commit('SET_PRODUCT_STORE_ERROR', error.message || 'Ошибка при загрузке категорий');
        console.error('Error fetching productStore:', error);
      } finally {
        commit('SET_PRODUCT_STORE_LOADING', false);
      }
    }
  },
  getters: {
    productStore: state => state.productStore,
    productStoreLoading: state => state.productStoreLoading,
    productStoreError: state => state.productStoreError,
    productStoreLoaded: state => state.productStoreLoaded
  }
}